import { NavigationItem } from '../Navigation.types';

export const isElementActive = ({ path, isElementActiveValidator }: NavigationItem): boolean =>
  Boolean(isElementActiveValidator && isElementActiveValidator(path));
